import Header from "./Header";
import MainSection from "./MainSection";
import ContactSection from "./ContactSection";
import React from 'react';
import ImageCarousel from './ImageCarousel';
import Content from './Content';
import FooterComponent from './FooterComponent';

export default function App() {
	let images = [
		// 'image_3.png',
		// 'image_4.png',
		// 'image_5.png',
		// 'image_6.png',
		// 'image_7.png',
		// 'image_8.png',
		'image_9.png',
		'image_10.png',
		'image_11.png',
	];
	return (
		<>
			<div className='sticky top-0 z-10'>
				<Header />
			</div>
			<MainSection />
			<ImageCarousel images={images} />
			<Content />
			<ContactSection />
			<FooterComponent />
		</>
	);
}
